import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FullscreenLayoutingService {

  public get botIsVisible(): boolean {
    return localStorage.getItem('botIsVisible') === 'true';
  }

  public set botIsVisible(value: boolean) {
    localStorage.setItem('botIsVisible', value.toString());
  }

  public toggleBot() {

    this.botIsVisible = !this.botIsVisible;
  }
}
